<template>
  <div class="hundred_percent_form left_form gradefrom">
    <el-form
      :label-position="labelPosition"
      v-loading="loading"
      :rules="formRules"
      :model="formInfo"
      ref="ruleForm"
      label-width="100px"
    >
      <div v-for="(items,index) in formInfo.form" class="hundred_percent_form_left" :key="index">
        <el-row>
          <el-col :span="6">
            <el-form-item label="等级" prop>
              <el-input v-model="items.usergradesort" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item
              label="等级名称"
              :prop="'form.'+ index + '.usergradename'"
              :rules="formRules.usergradename"
            >
              <el-input v-model="items.usergradename" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item
              label="价格比率"
              :prop="'form.'+ index + '.usergraderate'"
              :rules="formRules.usergraderate"
            >
              <el-input v-model="items.usergraderate" clearable>
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer2">
      <el-button type="primary" @click="formSubmit" :loading="formLoading">保 存</el-button>
      <el-button @click="onCancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import { getList, update } from "../../api/setting/sysUserGrade";
const formJson = {
  housingid: "",
  housingname: "",
  areaname: "",
  areasort: ""
};
export default {
  data() {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入等级名称"));
      } else {
        callback();
      }
    };
    var checkRate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入价格比率"));
      } else {
        var reg = new RegExp("^([1-9]|[1-9]\\d|100)$");
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入1-100的整数"));
        }
      }
    };
    return {
      loading: true,
      formLoading: false,
      formInfo: { form: [] },
      labelPosition: "left",
      data: formJson,
      formRules: {
        usergradename: [
          { required: true, message: "不能为空", trigger: "blur" }
        ],
        usergraderate: [
          { required: true, message: "不能为空", trigger: "blur" },
          { validator: checkRate, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    onCancel() {
      this.getInfo();
      // 清空验证信息表单
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].clearValidate();
      }
    },
    getInfo() {
      this.loading = true;
      getList()
        .then(response => {
          if (response.code) {
            this.$message.error(response.message);
          }
          if (response.data) {
            this.formInfo.form = response.data;
          }
          setTimeout(() => {
            this.loading = false;
          }, 0.3 * 1000);
        })
        .catch(() => {});
    },
    formSubmit() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.formLoading = true;
          this.data.userGrades = JSON.stringify(this.formInfo.form);
          let ss = new URLSearchParams(this.data);
          // let data = Object.assign({}, data );

          // console.log(data);
          update(ss).then(response => {
            this.formLoading = false;
            if (response.code) {
              this.$message.error(response.message);
              return false;
            }
            this.$message.success("操作成功");
            //刷新表单
            this.getInfo();
            // 清空验证信息表单s
            if (this.$refs["ruleForm"]) {
              this.$refs["ruleForm"].clearValidate();
            }
          });
        }
      });
    }
  },
  created() {
    // 加载版本数据
    this.getInfo();
  }
};
</script>

<style type="text/scss" lang="scss">
body {
  margin: 0;
}
.form {
  padding: 20px;
  width: 40%;
}
.title {
  color: #606266;
  text-align: center;
  font-size: 18px;
  margin: 30px 0;
}
.hundred_percent_form_left {
  .el-form {
    display: flex;
  }
  .el-form-item {
    /*float: left;*/
    margin-right: 15px;
  }
}
.dialog-footer2 {
  margin-left: 100px;
}

.gradefrom {
  width: 80%;
}
.gradefrom .el-form-item__label {
  width: 80px !important;
}
.gradefrom .el-form-item__content {
  margin-left: 80px !important;
}
</style>
